import { TimerSandFullIcon } from './TimerSandFullIcon';

/**
 * author: Google
 * id E603301B-7DF4-43C2-9035-0DDB2A50B88E
 * name timer-sand-full
 * version: 1.9.32
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/timer-sand-full.svg
 * tags
 * - Date / Time 
 */
export const HourglassFullIcon = TimerSandFullIcon;
export default HourglassFullIcon